import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { SelfFixApplianceDetails } from '../../models/self-fix-appliance-details/self-fix-appliance-details.interface';

export const mockApplianceDetails: SelfFixApplianceDetails = {
  applianceCategory: 'Fridges & Freezers',
  applianceCode: 'CN',
  brandCode: ClientBrandCode.AEG,
};
